import { Text } from "react-internationalization";
import { connect } from "react-redux";
import React from 'react';
const TermsAndConditions = (props) => {
    console.log("yes-")
    return (
        <div>
            {props.agentLoggedIn===false && <div class="card mt-3">
                <h3 class="card-header block-heading">
                    <Text id="sharp.imp" /> : <Text id="sharp.impsub" />
                </h3>
                <div class="panel">
                    <div class="card-body">
                        <ul>
                            {

                                (props.selectedPlan === "SDAB20" ||
                                   props.selectedPlan === "SDABWD20" ||
                                    props.selectedPlan === "SDAP20" ||
                                    props.selectedPlan === "SDAPWD20")
                                    ? (
                                        <>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li><Text id="sharp.imp1" />.</li>
                                        </>
                                    ) : (


                                        <li>
                                            <Text id="sharp.imp1" />.
                                        </li>

                                    )}
                            <li>
                                <Text id="sharp.imp2" />.
                            </li>
                            <li>
                                <Text id="sharp.imp3" />.
                            </li>
                            <li>
                                <Text id="sharp.imp4" />.
                            </li>
                            <li>
                                <Text id="sharp.imp5" />.
                            </li>
                            <li>
                                <Text id="sharp.imp6" />.
                            </li>

                            {props.year === "2022" || props.year === "2023" ||props.year==="2024" ? (
                                <li>

                                    <Text id="sharp.imp7" />:{" "}
                                    <br />

                                    <Text id="sharp.imp7sub1" />
                                    <br />
                                    <Text id="sharp.imp7sub2" />.

                                </li>
                            ) : null}

                            {props.year === "2023" || props.year === "2024" ?
                                <li> <Text id="sharp.imp10" /></li>
                                : null}
                            <br />
                        </ul>
                    </div>
                </div>
            </div>}
        </div>)
}
const mapStateToProps = (state) => {
    return {
        agentLoggedIn: state.login.agentLoggedIn,
        year: state.webApp.year?.planYear,
    };
};
const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);